import { IGetMessagesV2Response, IMessage, StreamStatus } from '../../../api/types';

/**
 * Flatten the pages
 * set `reverse == false` if you don't care about the order
 *
 * @param pages
 * @param reverse
 */
export const messagesUnwrapPages = (
    pages?: IGetMessagesV2Response[],
    reverse: boolean = true
): IMessage[] | undefined => {
    if (!pages) {
        return pages;
    }

    // fix the issue with the `Proxy` object
    const _pages = Array.from(pages ?? []);

    if (reverse) {
        _pages.reverse();
    }

    return _pages.map(({ messages }) => messages).flat();
};

const finishedStatus = [StreamStatus.DONE, StreamStatus.FAILED, StreamStatus.ABORTED];
export const isConversationHasGeneratingMessage = (messages: IMessage[] = []) => {
    const totalMessages = messages.length;

    if (totalMessages === 0) {
        return false;
    }

    const lastMessage = messages[totalMessages - 1];

    return Boolean(lastMessage.status && !finishedStatus.includes(lastMessage.status) && !lastMessage.app_id);
};
